"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Products = exports.ProductSelected = exports.Product = exports.ADSOffer = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
/* istanbul ignore next */

var Product = _propTypes.default.shape({
  productType: _propTypes.default.string,
  productTerm: _propTypes.default.number,
  minimumApr: _propTypes.default.string,
  minimumAmount: _propTypes.default.string,
  maximumAmount: _propTypes.default.string,
  loanAmount: _propTypes.default.string,
  minMonthlyPayments: _propTypes.default.string,
  valid: _propTypes.default.bool,
  adminFeePercent: _propTypes.default.string,
  clientCosts: _propTypes.default.string,
  minimumPaymentDue: _propTypes.default.strig,
  minimumTotalCost: _propTypes.default.string
});
exports.Product = Product;
var Products = _propTypes.default.arrayOf(Product);
exports.Products = Products;
var ADSOffer = _propTypes.default.shape({
  term: _propTypes.default.number,
  minMonthlyPayments: _propTypes.default.string,
  maxMonthlyPayments: _propTypes.default.string,
  apr: _propTypes.default.string,
  minimumTotalCost: _propTypes.default.string,
  maximumTotalCost: _propTypes.default.string
});
exports.ADSOffer = ADSOffer;
var ProductSelected = _propTypes.default.shape({
  loanAmount: _propTypes.default.string,
  term: _propTypes.default.number,
  rate: _propTypes.default.string,
  selectedRadio: _propTypes.default.string
});
exports.ProductSelected = ProductSelected;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-revisions-v2/dist/pf-revisions.scss');